var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup269(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1416 24.7583C48.1416 11.9914 37.7835 1.63335 25.0166 1.63335C12.2497 1.63335 1.8916 11.9914 1.8916 24.7583C1.8916 37.5253 12.2497 47.8833 25.0166 47.8833C37.7835 47.8833 48.1416 37.5253 48.1416 24.7583Z",
    stroke: "#9BA9B6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1626 38.2479H28.8709M34.6522 20.9403V23.8213C34.6522 28.5692 29.7646 32.4306 25.0168 32.4306C20.2689 32.4306 15.3813 28.5692 15.3813 23.8213V20.9403M25.0168 32.4667V38.2479",
    stroke: "#9BA9B6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7979 15.1229C30.7979 11.93 28.2095 9.34167 25.0166 9.34167C21.8237 9.34167 19.2354 11.93 19.2354 15.1229V22.8313C19.2354 26.0242 21.8237 28.6125 25.0166 28.6125C28.2095 28.6125 30.7979 26.0242 30.7979 22.8313V15.1229Z",
    fill: "#9BA9B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup269);
export default __webpack_public_path__ + "static/media/Group 269.eef69f219a9041be35bdf06c5c888477.svg";
export { ForwardRef as ReactComponent };